/* istanbul ignore file */
'use client'

import { DatadogBrowserAdapter } from './adapters/datadog-browser'
import { AnalyticsManager } from './manager'

let clientAnalytics: AnalyticsManager | null = null

export function getClientAnalytics(): AnalyticsManager {
  if (!clientAnalytics) {
    clientAnalytics = new AnalyticsManager()
    clientAnalytics.register(new DatadogBrowserAdapter())
  }

  return clientAnalytics
}

// The Datadog RUM SDK itself is booted at module load in each app's
// `instrumentation-client.ts`, so there is no key to pass and nothing to load
// here. This call exists to flip the manager's `initialized` flag — until it
// runs, `track`/`identify` no-op by design.
//
// `<Analytics />` calls it, and that component only mounts inside authenticated
// layouts, which keeps custom actions scoped to signed-in users. It also keeps a
// lifecycle hook for any future adapter that *does* need a key. Idempotent.
export function initClientAnalytics(): void {
  if (typeof window === 'undefined') return
  getClientAnalytics().init()
}
